<div
  class="container" [ngClass]="typePopup"
  [style.width.vw]="width"
  [@showHide]="{ value: animationState, params: { height: height } }"
  (@showHide.start)="onShowHide($event)"
  (@showHide.done)="onShowHide($event)"
  >
  @for (popupMenuItem of popupMenuItems; track popupMenuItem) {
    <aa-colored-popup-menu-item
      class="popitem"
      [typePopup]="typePopup"
      [popupMenuItem]="popupMenuItem"
    ></aa-colored-popup-menu-item>
  }
</div>
